import { render } from "./manage-document.vue?vue&type=template&id=d1598dbc"
import script from "./manage-document.vue?vue&type=script&lang=js"
export * from "./manage-document.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__